









































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
	import TestDetailBase from "./TestDetailBase";

	@Component
	export default class TestDetail extends TestDetailBase {

	 	 	
		created() {
			this.returnRoute = "TenantList";
			super.initializeRights('COR_NationalHoliday_Create', 'COR_NationalHoliday_Delete', 'COR_NationalHoliday_Read', 'COR_NationalHoliday_Update');
			super.setMainDescription('nationalHoliday.new', 'nationalHoliday.detail');
            this.mainDataChanged = false;
		}

        preventRefresh(event: any) {
            if (this.$store.state.askBeforeCancelEditing === true && this.formIsInEditMode && this.dataWasChanged()) {
                event.preventDefault(); event.returnValue = "";
            }
		}

        beforeMount() {
            
        }

        beforeDestroy() {
         
        }

		mounted() {
			super.mounted();
		};

	


	}
